import { TaxRate } from '../TaxRate';
import { Store } from '../../wrappers';
export class TaxRateLocalizationSr {
    taxRate;
    constructor(taxRate) {
        this.taxRate = taxRate;
    }
    static getZeroTaxRate() {
        const venue = Store.get('tenant')?.venue;
        if (venue && !venue.taxes_enabled) {
            return TaxRate.getTaxesDisabledTaxRate();
        }
        return TaxRate.all().find(taxRate => (taxRate.name === 'VAT' || taxRate.name === 'Без ПДВ') && +taxRate.rate === 0);
    }
    static getTaxesDisabledTaxRate() {
        return TaxRate.all().find(taxRate => (taxRate.name === 'VAT-EXCL' || taxRate.name === 'Није у ПДВ') && +taxRate.rate === 0);
    }
    static productTaxRates() {
        return TaxRate.all().filter(taxRate => {
            return taxRate.type === TaxRate.TYPE_TAX_ON_NET;
        });
    }
}
const TaxRateLocalizationSrStatic = TaxRateLocalizationSr;
//# sourceMappingURL=TaxRateLocalizationSr.js.map